/**
 * @Author  : neo
 * @Date    : Created in 2020/10/19 8:42 下午
 * @Email   : liuhuan@everimaging.com
 */
import request from "./request";

// // 获取功能引导列表
// export function getToolGuideList(params) {
//   return request({
//     url: '/api/admin/tool_guide/list',
//     method: 'get',
//     params
//   })
// }

// // 更新功能引导
// export function opToolGuide(data) {
//   return request({
//     url: '/api/admin/tool_guide/op',
//     method: 'post',
//     data
//   })
// }

// // 删除功能引导
// export function deleteToolGuide(data) {
//   return request({
//     url: '/api/admin/tool_guide/delete',
//     method: 'delete',
//     data
//   })
// }

export function getToolGuideById(params: number) {
  return request({
    url: "/website/api/tool-guide/detail/" + params,
    method: "get"
  });
}
